import * as React from 'react';
import { Icon } from '../Icon';
import { IIcon } from '../../interfaces/IIcon';

export function Position(props: IIcon) {
    const newViewProps = '0 0 485.142 485.142' ?? props.viewBox;
    return (
        <Icon
            width={props.width}
            height={props.height}
            viewBox={newViewProps}
            style={props.style}
            className={props.className}
        >
 		<g>
			<path d="M460.49,95.645h-88.625c-13.617,0-24.652,11.027-24.652,24.648v63.984H283.23c-13.621,0-24.656,11.023-24.656,24.645
				v63.988H194.59c-13.621,0-24.652,11.039-24.652,24.646v67.07h-67.055c-6.543,0-12.813,2.594-17.434,7.211
				c-4.625,4.62-7.219,10.918-7.219,17.435l0.008,51.569c0,13.634,11.039,24.66,24.652,24.66h357.6
				c13.621,0,24.651-11.026,24.651-24.66V120.292C485.143,106.672,474.111,95.645,460.49,95.645z"/>
			<path d="M330.756,24.605c-6.344-6.504-16.736-6.629-23.236-0.301C202.097,127,101.804,227.305,4.816,324.284
				C1.73,327.37,0,331.562,0,335.913v112.47c0,9.064,7.355,16.438,16.434,16.438c9.07,0,16.438-7.371,16.438-16.438V342.714
				c95.414-95.418,194.059-194.012,297.578-294.871C336.947,41.516,337.08,31.105,330.756,24.605z"/>
		</g>
        </Icon>
    );
}
